import { makeAutoObservable } from 'mobx';

export default class AdminStore {
    _isAuth: boolean;
    _id: number;
    _email: string;
    _connect: boolean;

    constructor() {
        this._isAuth = false;
        this._id = 1;
        this._email = '';
        this._connect = false;
        
        makeAutoObservable(this);
    };

    setIsAuth(bool: boolean) {
        this._isAuth = bool;
    };
    setId(num: number) {
        this._id = num;
    };
    setEmail(email: string) {
        this._email = email;
    };
    setConnect(bool: boolean) {
        this._connect = bool;
    };

    get isAuth() {
        return this._isAuth;
    };
    get id() {
        return this._id;
    };
    get email() {
        return this._email;
    };
    get connect() {
        return this._connect;
    };
};